/**
 * Trigger: tr_account_initial_balances_update
 * Purpose: Update account balances when initial balance details change
 * Table: account_initial_balances
 * Event: UPDATE OF account_id, currency_id, balance_date, initial_balance
 */
export const TR_ACCOUNT_INITIAL_BALANCES_UPDATE = `
CREATE TRIGGER tr_account_initial_balances_update
UPDATE OF account_id, currency_id, balance_date, initial_balance ON account_initial_balances
BEGIN
  UPDATE account_balances
  SET initial_balance = 0
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET initial_balance = 0
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.balance_date;

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_id, new.balance_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_id, new.balance_date);

  UPDATE account_balances
  SET initial_balance = new.initial_balance
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id;

  UPDATE account_daily_balances
  SET initial_balance = new.initial_balance
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id
    AND balance_date = new.balance_date;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_daily_balances
  WHERE account_id = new.account_id
    AND account_id != old.account_id
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );

  DELETE FROM account_activity_dates
  WHERE account_id = new.account_id
    AND account_id != old.account_id
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );
END;
`;
